import { ErrorMsg } from 'commonTypes'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDataContext } from 'context/DataContext'
import { Routes } from 'common/routeConfig'
import DruggableTargetsCard from '../../components/targetsCard/TargetsCard'
import ReportMenuCommonLayout from '../../components/reportMenuCommonLayout/ReportMenuCommonLayout'

type TargetsProps = {
    isMenuOpen: boolean
}

const Targets: React.FC<TargetsProps> = ({ isMenuOpen }) => {
    const { t } = useTranslation('targets')

    const [isLoading] = useState<boolean>(false)
    const [error] = useState<boolean>(false)
    const [errorMsg] = useState<ErrorMsg>()
    const { targets } = useDataContext()

    const listViewBoxRef = useRef<HTMLSpanElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (!targets) {
            navigate(Routes.BASE)
            window.location.reload()
        }
    }, [targets, navigate])

    return (
        <ReportMenuCommonLayout
            isLoading={isLoading}
            isMenuOpen={isMenuOpen}
            title={t('listTitle')}
            targetUrl="targets"
            error={error}
            errorMsg={errorMsg}
            scrollRef={listViewBoxRef}
            ref={containerRef}
            hasFilters={true}
            subtitle={''}
            tableTitle={''}
        >
            <DruggableTargetsCard
                targets={targets}
                hideSubtitle
                hideSeeAllButton
            />
        </ReportMenuCommonLayout>
    )
}

export default Targets
